import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Row, Col} from 'react-bootstrap';
import PropTypes from 'prop-types';
import PageTitle from '../page-title/index';
import {loadPageContent} from '../../../actions/content';
import ArticleList from '../article/article-list';
import InlineCKEditor from '../editor/inline-editor';

class NewsPage extends Component {
  static propTypes = {
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    articles: PropTypes.array,
    contents: PropTypes.any.isRequired,
    // slug: PropTypes.string.isRequired,
    slug: (props) => {
      if (!/([a-z]+)(-{1}[a-z]+)*/.test(props.slug)) {
        return new Error('Page slug should only contain alphabet and dash characters!');
      }
      return null;
    },
    loading: PropTypes.bool
  };

  static defaultProps = {
    loading: false,
  };

  componentDidMount() {
    const {dispatch, slug} = this.props;
    dispatch(loadPageContent(`api/pages/${slug}`));
  }

  handleContentSaved = () => {
    const {dispatch, slug} = this.props;
    dispatch(loadPageContent(`api/pages/${slug}`));
  };

  render() {
    const {
      contents, articles, slug, title, className, loading
    } = this.props;

    return (
      <Grid fluid className={className}>
        <Row>
          <Col lg={12}>
            <PageTitle>{title}</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <InlineCKEditor
              identifier={`${slug}_content_text`}
              onContentSaved={this.handleContentSaved}
              contents={contents[`${slug}_content_text`]}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            {loading ? <div>Loading articles... </div> : <ArticleList articles={articles}/>}
          </Col>
        </Row>
      </Grid>
    );
  }
}


const mapStateToProps = state => ({
  contents: state.content.list
});

export default connect(mapStateToProps)(NewsPage);



// WEBPACK FOOTER //
// ./src/components/common/news-page/news-page.jsx